module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av422-bd3d3cf07def74d218eb0921f335191c.jpg";